export default __webpack_public_path__ + "static/media/empty_order.be6042e2.png";